module.exports = __webpack_public_path__ + "media/images/news/whatsapp-web-2-88a2cfd080d84ff5234135236bdff017.gif";